var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Delete MySQL user")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("p", [
              _vm._v("Are you sure you wish to "),
              _c("strong", [_vm._v("permanently")]),
              _vm._v(" remove the user “" + _vm._s(_vm.user.user) + "”?")
            ])
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteDatabase
                }
              },
              [_vm._v("Delete")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }